import type { ReviewsSummary } from "./types";

type ReviewsBadgeProps = {
  summary: ReviewsSummary;
  onClick: () => void;
  isLoading?: boolean;
};

function StarIcon({ filled }: { filled: boolean }) {
  return (
    <svg
      className={`w-5 h-5 ${filled ? "text-primary fill-primary" : "text-muted-foreground"}`}
      fill={filled ? "currentColor" : "none"}
      stroke="currentColor"
      strokeWidth={1.5}
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
      />
    </svg>
  );
}

export function ReviewsBadge({ summary, onClick, isLoading }: ReviewsBadgeProps) {
  if (isLoading) {
    return (
      <div className="inline-flex items-center gap-2 px-3 py-2 bg-muted rounded-full animate-pulse">
        <div className="w-5 h-5 bg-muted-foreground/20 rounded" />
        <div className="w-16 h-4 bg-muted-foreground/20 rounded" />
      </div>
    );
  }

  if (summary.reviewCount === 0) {
    return (
      <div className="inline-flex items-center gap-1.5 px-3 py-1.5 text-muted-foreground text-sm">
        <StarIcon filled={false} />
        <span>No reviews yet</span>
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-card border border-border rounded-full shadow-sm hover:shadow-md hover:border-primary/50 transition-all duration-200 cursor-pointer group"
    >
      <StarIcon filled={true} />
      <span className="font-semibold text-foreground">{(summary.averageRating / 2).toFixed(1)}</span>
      <span className="text-muted-foreground text-sm group-hover:text-foreground transition-colors">
        ({summary.reviewCount} {summary.reviewCount === 1 ? "review" : "reviews"})
      </span>
    </button>
  );
}

